import WorkReview from '@/components/visits/WorkReview';
import { useNavigationPresentation } from '@/lib/tradeNavigation';
import { useSearchParams } from 'react-router-dom';
import CrewPlanner from './CrewPlanner';
import TradesSchedule from './TradesSchedule';
export default function OperatingSchedule(){
  const presentation=useNavigationPresentation();const [params]=useSearchParams();
  if(presentation.pending)return <p className="p-6" role="status">Loading schedule…</p>;
  if(!presentation.trades || !['admin','office','super_admin'].includes(presentation.user?.role) || params.get('planning')==='day')return <CrewPlanner/>;
  if(params.get('view')==='review')return <WorkReview key={JSON.stringify([presentation.user.org_id,presentation.user.id,presentation.user.role,params.get('job_id')])}/>;
  return <TradesSchedule key={JSON.stringify([presentation.user.org_id,presentation.user.id,presentation.user.role])}/>;
}
